module.exports = __webpack_public_path__ + "img/HZ-S4045.c6106a3f.jpg";